module.exports = __webpack_public_path__ + "img/doorLogo7.20c6b93e.png";